/**
 * Usage:
 * import { sleep } from '@local_modules/generic/sleep/index.js'
 *
 * @param {Number} ms - Default 1000ms
 * @returns {Promise}
 */
export async function sleep (ms = 1000) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms)
  })
}
